import * as L from "react";
import { forwardRef as o } from "react";
const l = o(function(e, C) {
  return /* @__PURE__ */ L.createElement(
    "svg",
    {
      fill: "none",
      ref: C,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      ...e
    },
    /* @__PURE__ */ L.createElement(
      "path",
      {
        clipRule: "evenodd",
        d: "M2.57199 16.6436L7.00623 19.8095C7.18952 19.955 7.40734 20.0286 7.62781 20.0286C7.83411 20.0286 8.04396 19.9641 8.22902 19.8377L12.9183 16.8646V17.6774L12.4738 17.962L12.4747 17.9629L7.75088 20.9569C7.69687 20.9951 7.6163 21.0288 7.5313 20.9615L2 17.0119L2.57199 16.6436ZM2.57199 14.7588L7.00623 17.9247C7.18775 18.0693 7.40822 18.1447 7.64375 18.1447C7.83323 18.1447 8.03157 18.0957 8.22725 17.9947L12.9183 15.0571V15.7963L7.75088 19.0721C7.69687 19.1112 7.6163 19.144 7.5313 19.0776L2.89694 15.7681C2.8633 15.7353 2.82699 15.709 2.78626 15.689L2 15.1271L2.57199 14.7588ZM6.9416 10.0719L12.588 14.1988L7.7987 17.2001C7.76239 17.2201 7.63578 17.2755 7.5313 17.1919L2.89783 13.8842C2.8633 13.8505 2.82699 13.8233 2.78538 13.8033L2.00089 13.2432L6.9416 10.0719ZM9.38805 8.50073L15.378 12.764V16.1063L13.8037 17.1119V14.206C13.8037 14.1979 13.7993 14.1924 13.7984 14.1842C13.7984 14.1797 13.7957 14.1751 13.7948 14.1697C13.7842 14.0369 13.724 13.9133 13.6178 13.8351L7.75443 9.54997L9.38805 8.50073ZM20.1399 12.2431L20.7508 12.6722L16.2634 15.5399V14.7052L20.1399 12.2431ZM19.6546 9.99548L20.7552 10.7829L16.2634 13.636V12.7713C17.4827 11.9767 18.6373 11.0265 19.6546 9.99548ZM15.2841 3L20.9474 7.06782C19.683 8.89624 17.8466 10.6547 15.8287 11.9785L10.2009 7.97248C12.171 6.65503 13.9843 4.88662 15.2841 3Z",
        fill: "currentColor",
        fillRule: "evenodd"
      }
    )
  );
});
export {
  l as Cash
};
